/**
 * @module geo/payload/facade/services
 */

export abstract class SERVICE_PAYLOAD {

  /**
   * Has this service to be save on store?
   */
  transient ?: boolean
  /**
   * id of called service
   */
   id: string;
   constructor(options:Partial<SERVICE_PAYLOAD>){
     this.transient=options.transient;
     if(options.id){
        this.id=options.id;
      }else{
        throw Error('service id not defined in options parameters for service payload');
      }
   }
  
}

export interface ServicePayloadParameters{
  id:string,
  transient: boolean

}